import React from 'react';
import { useStore } from '../../store/useStore';
import { CheckCircle2, MapPin } from 'lucide-react';
export function ReserveConfirm() {
  const {
    products,
    shopperSelectedProductId,
    setShopperView
  } = useStore();
  const product = products.find(p => p.id === shopperSelectedProductId);
  if (!product) return null;
  return <div className="flex flex-col h-full bg-[#F4F5F6] p-4 pt-12" data-id="element-473">
      <div className="bg-white rounded-[18px] p-6 shadow-sm flex flex-col items-center text-center" data-id="element-474">
        <div className="w-16 h-16 bg-[#E9FAF8] rounded-full flex items-center justify-center mb-4" data-id="element-475">
          <CheckCircle2 className="w-8 h-8 text-[#00CDBE]" data-id="element-476" />
        </div>
        <h1 className="text-2xl font-bold text-[#252935] mb-2" data-id="element-477">Reserved.</h1>
        <p className="text-[#60646F] mb-6" data-id="element-478">
          Your price is locked until 8:00 PM.
        </p>

        <div className="w-full bg-[#F4F5F6] rounded-xl p-4 mb-6 text-left" data-id="element-479">
          <div className="flex gap-3 mb-3" data-id="element-480">
            <img src={product.image} alt={product.name} className="w-12 h-12 rounded-lg object-cover" data-id="element-481" />
            <div data-id="element-482">
              <h3 className="font-bold text-[#252935]" data-id="element-483">{product.name}</h3>
              <p className="text-sm text-[#60646F]" data-id="element-484">{product.dispensaryName}</p>
            </div>
          </div>
          <div className="flex justify-between items-center pt-3 border-t border-[rgba(37,41,53,0.12)]" data-id="element-485">
            <span className="text-[#60646F]" data-id="element-486">Total to pay at store</span>
            <span className="font-bold text-[#252935]" data-id="element-487">${product.price}</span>
          </div>
        </div>

        {product.status === 'Stashed' && <div className="w-full flex items-center gap-2 bg-[#E9FAF8] text-[#007E7A] p-3 rounded-xl text-sm font-medium mb-6 text-left" data-id="element-488">
            <CheckCircle2 className="w-5 h-5 shrink-0" data-id="element-489" />
            Stash guarantee: If it is wrong at pickup, we make it right.
          </div>}

        <div className="w-full space-y-3" data-id="element-490">
          <button className="w-full bg-[#F4F5F6] text-[#252935] font-bold py-3.5 rounded-full flex items-center justify-center gap-2 hover:bg-gray-200 transition-colors" data-id="element-491">
            <MapPin className="w-5 h-5" data-id="element-492" />
            Get directions
          </button>
          <button onClick={() => setShopperView('Browse')} className="w-full bg-[#00CDBE] text-white font-bold py-3.5 rounded-full hover:bg-[#00B8AA] transition-colors" data-id="element-493">
            Done
          </button>
        </div>
      </div>
    </div>;
}